export const isMobileBrowser = (): boolean => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }
  
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  
  // Check for mobile devices
  return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
};

export const getMobileOS = (): 'ios' | 'android' | null => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return null;
  }
  
  const userAgent = navigator.userAgent || navigator.vendor;
  
  // Check for iOS
  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return 'ios';
  }
  
  // Check for Android
  if (/android/i.test(userAgent)) {
    return 'android';
  }
  
  return null;
};

export const isIOS = (): boolean => {
  return getMobileOS() === 'ios';
};

export const isAndroid = (): boolean => {
  return getMobileOS() === 'android';
};

export const openMobileApp = (path: string = 'profile'): void => {
  const deepLink = `referpal://${path}`;
  const appStoreLink = 'https://apps.apple.com/app/referpal'; // Update with actual App Store URL
  const playStoreLink = 'https://play.google.com/store/apps/details?id=com.referpal.app';
  
  const mobileOS = getMobileOS();
  
  console.log('🔗 Attempting to open mobile app:', deepLink);
  
  // Try to open deep link
  window.location.href = deepLink;
  
  // If app is not installed, redirect to appropriate store after a delay
  const fallbackTimer = setTimeout(() => {
    console.log('⚠️ App not detected, redirecting to store...');
    
    if (mobileOS === 'ios') {
      // window.location.href = appStoreLink;
      console.log('Would redirect to App Store:', appStoreLink);
    } else if (mobileOS === 'android') {
      // window.location.href = playStoreLink;
      console.log('Would redirect to Play Store:', playStoreLink);
    }
  }, 2500);
  
  // Clear timeout if user comes back (app opened successfully)
  window.addEventListener('blur', () => {
    console.log('✅ Window blurred - app likely opened');
    clearTimeout(fallbackTimer);
  });
};
